import { Trans } from '@lingui/react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { FunctionComponent } from 'react'
import React from 'react'

export interface AllowToContinueProps {
  message?: string
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))

const AllowToContinue: FunctionComponent<AllowToContinueProps> = props => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography id='allowToContinue' variant='h5' gutterBottom={true}>
        <Trans id='' message='Intenta ingresar a una cita fuera del horario' />
      </Typography>
      <Typography variant='body1' gutterBottom={true}>
        <Trans
          id=''
          message='Aún no es el horario de su cita. Si lo desea puede continuar a la sala, sin embargo el médico tal vez no podrá atenderlo:'
        />
      </Typography>
      {!props.message && (
        <Alert id='alertError' severity='error'>
          <Trans id='' message='Datos de acceso son incorrectos.' />
        </Alert>
      )}
      {props.message && (
        <>
          <Alert id='alertError' severity='error'>
            {props.message}
          </Alert>
          <Grid container={true} justify='center'>
            {props.children}
          </Grid>
        </>
      )}
    </div>
  )
}

export default AllowToContinue
